import * as Yup from 'yup';
import { EIGHT_DIGITS_REGEX } from '../constants/patterns';

const getRequiredClaimNumberLength = (claimNumber = '') => {
  // returns number of digits needed after XX/00-
  const defaultLength = 6;
  if (claimNumber.length < 2) {
    return defaultLength;
  }
  // NOTE: for now on for all cases we return 6
  switch (claimNumber.slice(0, 2).toUpperCase()) {
    case 'MM':
    case 'TR':
    case 'PA':
    case 'MC':
      return 6;
    default:
      return defaultLength;
  }
};

const isClaimNumberValid = (claimNumber) => {
  const requiredLength = getRequiredClaimNumberLength(claimNumber);
  const re = new RegExp(`^[A-Z]{2}/\\d{2}-\\d{${requiredLength}}$`);
  return re.test(claimNumber);
};

export const claimStatusValidationSchema = Yup.object().shape({
  clm: Yup.string()
    .test(
      'isClaimNumberValid',
      'validationErrors.invalidClaimNumber',
      isClaimNumberValid,
    )
    .required('validationErrors.isRequired'),
  dob: Yup.string()
    .nullable()
    .when(['isLegal'], {
      is: (isLegal) => !isLegal,
      then: Yup.string().required('validationErrors.isRequired'),
      otherwise: Yup.string().strip(),
    }),
  hvhh: Yup.string().when(['isLegal'], {
    is: (isLegal) => isLegal,
    then: Yup.string()
      .matches(EIGHT_DIGITS_REGEX, 'validationErrors.eightDigitsOnly')
      .required('validationErrors.isRequired'),
    otherwise: Yup.string().strip(),
  }),
});

export default claimStatusValidationSchema;
